export default function BriefCallout({ title, icon: Icon, children }) {
  return (
    <div className="brief-callout">
      <div className="brief-callout-title">
        {Icon && <Icon size={11} />}
        {title}
      </div>
      {children}
    </div>
  );
}
